import { QuestionType } from './QuestionType';

export enum QuestionSegment {
  GoodQuestion,
  BadQuestion,
}

export interface TSQuestionConfig {
  id: number;
  trackingId: string;
  state: string;
  thankYouMessageGood: string;
  thankYouMessageBad: string;
  questions: Question[];
}

export interface Question {
  id: number;
  questionId: string;
  questionSegment?: QuestionSegment;
  questionType: QuestionType;
  index: number;
  label: string;
  isRequired: boolean;
  hasOther?: boolean;
  questionOptions?: QuestionOption[];
  linearScaleOption?: LinearScaleOption | null;
  validationType?: string;
}

export interface LinearScaleOption {
  id: number;
  highScale: number;
  highScaleLabel: string;
  lowScaleLabel: string;
  lowScale: number;
}

export interface QuestionOption {
  id: number;
  questionOptionId: string;
  index: number;
  value: string;
}

export interface BRTQuestion extends Question {}
